import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/FEED/ITEMS';
export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH`, (olderThan, institutionId) => ({olderThan, institutionId}));

export const {
    action: fetchSingle,
    success: fetchSingleSuccess,
    failed: fetchSingleFailed,
} = createAction(
    `${domain}/FETCH_SINGLE`,
    feedItemId => ({feedItemId}),
    feedItem => ({feedItem}),
);

export const {
    action: updateItem,
    success: updateItemSuccess,
    failed: updateItemFailed,
} = createAction(
    `${domain}/UPDATE_ITEM`,
    (postId, recipients, from, body, nextStep, files, statements, isObservation, observedAt, disableFeedback) => ({
        postId,
        recipients,
        from,
        body,
        nextStep,
        files,
        statements,
        isObservation,
        observedAt,
        disableFeedback,
    }),
    (originatorId, item, isObservation) => ({originatorId, item, isObservation}),
);

export const {
    action: like,
    success: likeSuccess,
    failed: likeFailed,
} = createAction(
    `${domain}/LIKE`,
    originatorId => ({originatorId}),
    originatorId => ({originatorId}),
);

export const {
    action: unlike,
    success: unlikeSuccess,
    failed: unlikeFailed,
} = createAction(
    `${domain}/UNLIKE`,
    originatorId => ({originatorId}),
    originatorId => ({originatorId}),
);

export const {
    action: comment,
    success: commentSuccess,
    failed: commentFailed,
    aborted: commentAborted,
} = createAction(
    `${domain}/COMMENT`,
    (originatorId, body, imageIds) => ({originatorId, body, imageIds}),
    (originatorId, comment) => ({originatorId, comment}),
    ({error, originatorId}) => ({error, originatorId}),
    originatorId => ({originatorId}),
);

export const {
    action: deleteComment,
    success: deleteCommentSuccess,
    failed: deleteCommentFailed,
    aborted: deleteCommentAborted,
} = createAction(
    `${domain}/DELETE_COMMENT`,
    (originatorId, commentId) => ({originatorId, commentId}),
    (originatorId, commentId) => ({originatorId, commentId}),
    null,
    (originatorId, commentId) => ({originatorId, commentId}),
);

export const {
    action: likeComment,
    success: likeCommentSuccess,
    failed: likeCommentFailed,
} = createAction(
    `${domain}/LIKE_COMMENT`,
    (originatorId, commentId, like) => ({originatorId, commentId, like}),
    (originatorId, commentId, like) => ({originatorId, commentId, like}),
);

export const {
    action: fetchCommentsAndLikes,
    success: fetchCommentsAndLikesSuccess,
    failed: fetchCommentsAndLikesFailed,
} = createAction(
    `${domain}/FETCH_COMMENTS_AND_LIKES`,
    originatorId => ({originatorId}),
    (originatorId, likes, comments) => ({originatorId, likes, comments}),
);

export const {
    action: deleteItem,
    success: deleteItemSuccess,
    failed: deleteItemFailed,
    aborted: deleteItemAborted,
} = createAction(
    `${domain}/DELETE`,
    (originatorId, feedItemId, observationId) => ({originatorId, feedItemId, observationId}),
    (originatorId, feedItemId, observationId) => ({originatorId, feedItemId, observationId}),
);

export const {
    action: bookmarkItem,
    success: bookmarkItemSuccess,
    failed: bookmarkItemFailed,
} = createAction(
    `${domain}/BOOKMARK_ITEM`,
    feedItemId => ({feedItemId}),
    feedItemId => ({feedItemId}),
    (feedItemId, e) => ({feedItemId, e}),
);

export const {
    action: unBookmarkItem,
    success: unBookmarkItemSuccess,
    failed: unBookmarkItemFailed,
    aborted: unBookmarkItemAborted,
} = createAction(
    `${domain}/UNBOOKMARK_ITEM`,
    feedItemId => ({feedItemId}),
    feedItemId => ({feedItemId}),
    (feedItemId, e) => ({feedItemId, e}),
    feedItemId => ({feedItemId}),
);
